//#region imports

import {useTranslation} from "react-i18next";
import {APP_URLS} from '../../app/config/urls';
import {NoProfilePhoto} from '../../assets/images';
import ConsumerRankIcon from './consumerRankIcon';
import ComplaintMessageEditForm from "../forms/complain/ComplaintMessageEditForm/complaintMessageEditForm";
import {useState} from "react";
import axios from "axios";
import {STORAGE} from "../../app/config";
import {Button} from "@mui/material";
import ConfirmModal from "../modals/ConfirmModal";
import {LAYOUT_CONFIG} from "../../layoutConfig";
import {format} from "../../utils/timeZoneUtils";

//#endregion

function ComplainMessage({data: item, onDelete}) {
    const [data, setData] = useState(item);
    const isAvatarSet = data.reporter?.avatar?.split('/')?.filter((s) => !!s)?.length > 1 ?? false;
    const {t} = useTranslation('ComplainDetailsScreen', {keyPrefix: 'Messages'});
    const {t: tMessage} = useTranslation('Modals', {keyPrefix: 'Messages'});
    const [isEditMode, setIsEditMode] = useState(false);
    const [openConfirmModal, setOpenConfirmModal] = useState(false)
    const serverUrl = process.env.REACT_APP_SERVER_URL;
    const handleCloseConfirmationModal = () => {
        setOpenConfirmModal(false);
    }

    const token = JSON.parse(localStorage.getItem(STORAGE.ACCESS_TOKEN_KEY))?.token;
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
    }
    
    const confirmEdit = (message, attachments) => {
        const attachmentsIds = attachments.map(a => a.id);

        try {
            const token = JSON.parse(localStorage.getItem(STORAGE.ACCESS_TOKEN_KEY))?.token;
            axios.put(`${APP_URLS.EDIT_MESSAGE}/${item.id}`,
                {Content: message, Attachments: attachmentsIds},
                {
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + token,
                    }
                }).then(response => {
                setData({...item, message, attachments});
            })
        } catch (error) {
            console.log('error :>> ', error);
        }
        
    }


    const confirmDelete = () => {
        try {
            onDelete(item.id);
        } catch (error) {
            console.log('error :>> ', error);
        }
    }
    

    return (
        <div className={`fk-complain-message ${data.reporter ? '--reporter' : data.company ? '--company' : '--admin'}`}>
            <div className="fk-complain-message--header" style={{
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'space-between',
                flexDirection: 'column',
                maxWidth: '30%',
            }}>
                <div>
                <span className="fk-complain-message--created-at">
                    {format(data.timestamp)}
                </span>
                    {data.reporter &&
                        <div className="fk-complain-message--header-addressat --creator">
                            {t('from')}
                            <div className="fk-complain-message--header-addressat-name">
                                <div className="avatar-container">
                                    <img src={isAvatarSet ? `${APP_URLS.BASE}${data.reporter?.avatar}` : NoProfilePhoto}
                                         alt=""/>
                                </div>
                                {data.reporter?.initials}
                                <ConsumerRankIcon rank={data.reporter?.localizedRank} width={26} height={26}
                                                  className="rank-image"/>
                            </div>
                        </div>
                    }
                    {data.company &&
                        <div className="fk-complain-message--header-addressat">
                            {t('from')}
                            <div className="fk-complain-message--header-addressat-name">
                                {data.company?.name}
                            </div>
                        </div>
                    }
                    {data.admin &&
                        <div className="fk-complain-message--header-addressat">
                            {t('from')}
                            <div className="fk-complain-message--header-addressat-name">
                                From Moderator
                            </div>
                        </div>
                    }
                </div>
                <div style={{display: 'flex', flexDirection: 'row'}}>
                    <Button sx={{color: 'var(--base-ui-color)', borderRight: '1px solid var(--base-ui-color)', borderBottomRightRadius: 0, borderTopRightRadius: 0}} onClick={() => setIsEditMode(true)}>{t('Edit')}</Button>
                    <Button sx={{color: 'var(--base-ui-color)', borderBottomLeftRadius: 0, borderTopLeftRadius: 0}} onClick={() => setOpenConfirmModal(true)}>Delete</Button>
                </div>
            </div>
            {isEditMode ?
                <ComplaintMessageEditForm message={data} onConfirm={confirmEdit} onCancel={() => setIsEditMode(false)}/>
                : <div className={`fk-complain-message--body${data.admin ? ' --admin' : ''}`}>
                    <p className="fk-complain-message--description">
                        {data.message}
                    </p>
                    {data.attachments.length > 0 &&
                        <ul className="fk-files-list">
                            <li>
                                {t('attachments')}
                                <a href={`${serverUrl}/api/Report/${data.id}/downloadAllMessageAttachments`}
                                   target="_blank" rel="noreferrer">[Download all attachments]</a>
                            </li>
                            {data.attachments.map((file) => (
                                <li key={file.fileName}>
                                    {file.fileName}
                                    <a href={`${serverUrl}${file.path}`} target="_blank" rel="noreferrer">[Download attachment]</a>
                                </li>
                            ))}
                        </ul>
                    }
                </div>}
            <ConfirmModal title={tMessage('ConfirmDelete')} open={openConfirmModal} onClose={handleCloseConfirmationModal} onConfirm={confirmDelete} />
        </div>
    );
}

export default ComplainMessage;